
// Mapping between unit types in section.json and StiKo appartments is described here:
// https://docs.google.com/spreadsheets/d/1_USeR2Pxcez3-SggNiIM-FQMRV87IfQw0aeOmi5f0Pg/edit#gid=246734488

import { unitTypeEnum } from "../unit-type-enum";

export enum apartmentEnum {
    unknown = 'unknown',
    G_S1 = 'G-S1',
    G_S2 = 'G-S2',
    G_M = 'G-M',
    G_L1 = 'G-L1',
    G_L2 = 'G-L2',
    G_XL = 'G-XL',
    C_S1 = 'C-S1',
    C_S2 = 'C-S2',
    C_M1 = 'C-M1',
    C_M2 = 'C-M2',
    C_L1 = 'C-L1',
    C_L2 = 'C-L2',
    C_XS = 'C-XS',
    C_XL = 'C-XL',
    C_M = 'C-M',
    C_L = 'C-L',
    H_S = 'H-S',
    H_M1_2 = 'H-M1-2',
    H_M1_3 = 'H-M1-3',
    H_M2_2 = 'H-M2-2',
    H_M2_3 = 'H-M2-3',
    H_L1_2 = 'H-L1-2',
    H_L1_3 = 'H-L1-3',
    H_L2_2 = 'H-L2-2',
    H_L2_3 = 'H-L2-3',
}

export type ApartmentMap = {
    apartment: apartmentEnum;
    map?: unitTypeEnum[];
    amount: number;
}

export const apartmentMapping: () => ApartmentMap[] = () => [
    {
        apartment: apartmentEnum.unknown,
        map: [
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.G_S1,
        map: [
            unitTypeEnum.G_S1_R,
        ],
        amount: 0
    }, {
        apartment: apartmentEnum.G_S2,
        map: [
            unitTypeEnum.G_S2_R,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.G_M,
        map: [
            unitTypeEnum.G_M_R,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.G_L1,
        map: [
            unitTypeEnum.G_L1_R,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.G_L2,
        map: [
            unitTypeEnum.G_L2_R,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.G_XL,
        map: [
            unitTypeEnum.G_XL_R,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.C_S1,
        map: [
            unitTypeEnum.C_S1,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.C_S2,
        map: [
            unitTypeEnum.C_S2,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.C_XS,
        map: [
            unitTypeEnum.C_XS,
        ],
        amount: 0
    }, 
    {
        apartment: apartmentEnum.C_XL,
        map: [
            unitTypeEnum.C_XL,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.C_M,
        map: [
            unitTypeEnum.C_M,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.C_L,
        map: [
            unitTypeEnum.C_L,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.H_S,
        map: [
            unitTypeEnum.H_S_R,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.H_M1_2,
        map: [
            unitTypeEnum.H_M1_R,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.H_M1_3,
        map: [
            unitTypeEnum.H_M13_R,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.H_M2_2,
        map: [
            unitTypeEnum.H_M2_R,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.H_M2_3,
        map: [
            unitTypeEnum.H_M23_R,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.H_L1_2,
        map: [
            unitTypeEnum.H_L_R,
        ],
        amount: 0
    },
    {
        apartment: apartmentEnum.H_L1_3,
        map: [
            unitTypeEnum.H_L3_R,
        ],
        amount: 0
    },
]

export type ColumnInfo = {
    totalGFA: number;
    totalUFA: number;
    apartmentData?: ApartmentMap[];
}